import { Asset, AssetsDebts, Debt, InitialDetails } from "@fla/components";
import { AIData, CurrentUser, SliceStatus } from "interfaces";
import { initialState } from "pages/GetStarted/helper";
import { PersistState } from "redux-persist/es/types";

import { RootState } from "./rootReducer";

export const rootLogoutState: RootState = {
  user: {
    current: null as CurrentUser,
    status: SliceStatus.Idle,
    error: "",
    thirdPartyAuthStatus: SliceStatus.Idle,
    userCreatedInSession: false,
    _persist: {} as PersistState
  },

  getStarted: {
    initialDetails: {
      data: initialState,
      step: 1,
      isCompleted: false
    },
    ai: {} as AIData,
    status: SliceStatus.Idle,
    error: ""
  },

  consentOrders: {
    status: SliceStatus.Idle,
    error: "",

    base: {
      assetsDebts: {} as AssetsDebts,
      initialDetails: { isCompleted: false } as InitialDetails,
      submitted: false,
      uid: ""
    },

    initialDetailsStep: {
      passedSteps: [],
      currentStep: 1
    },
    assetsDebtsStep: {
      passedSteps: [],
      currentStep: 1
    },

    assets: [] as Asset[],
    debts: [] as Debt[]
  }
};
